import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dd3c167"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-active modal" }
const _hoisted_2 = { class: "modal-card rounded-borders" }
const _hoisted_3 = { class: "modal-card-body is-flex-direction-column" }
const _hoisted_4 = { class: "mb-2 ml-2" }
const _hoisted_5 = { class: "title-five" }
const _hoisted_6 = { class: "modal-card-foot justify-to-end" }

import i18n from '@/locales'
import { useComposableForEsc } from '@/components/common/modal/useComposableForEsc'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
  hideActions: Boolean
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {


useComposableForEsc({
  dismissFunction: () => close()
})

const close = () => emit('close')
const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-background",
      onClick: close
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "is-pulled-right delete",
            "aria-label": "close",
            onClick: close
          }),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "title")
          ])
        ]),
        _renderSlot(_ctx.$slots, "body")
      ]),
      _withDirectives(_createElementVNode("footer", _hoisted_6, [
        _renderSlot(_ctx.$slots, "actions", {}, () => [
          _createElementVNode("button", {
            class: "button",
            onClick: close
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('close')), 1)
          ])
        ])
      ], 512), [
        [_vShow, !__props.hideActions]
      ])
    ])
  ]))
}
}

})